import storage from '@Ravnur-Inc/helpers/storage';

import { STORAGE_GROUP, STORAGE_COOKIE_KEY, DEFAULT_COOKIES_NAME } from '../constants';

export function detectCookieName(): string {
  return storage.get(STORAGE_GROUP, STORAGE_COOKIE_KEY) || DEFAULT_COOKIES_NAME;
}
